import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_b_img = _resolveComponent("b-img");
  return _openBlock(), _createBlock(_component_b_img, {
    alt: "Card Logo",
    src: $options.cardLogoImage,
    class: "img-responsive"
  }, null, 8, ["src"]);
}